
// import React, { useRef } from 'react';
// import { 
//     RiAddLine, 
//     RiSubtractLine, 
//     RiHotelBedLine,
//     RiInformationLine,
//     RiDeleteBinLine,
//     RiDraggable,
//     RiCalendarEventLine
// } from "react-icons/ri";
// import cityData from "../../Data/PackageDestinations.json";
// import "./InteractiveCitySelector.css";

// // Helper to format date "29 Nov"
// const formatDateShort = (dateObj) => {
//     if (!dateObj || isNaN(dateObj.getTime())) return '';
//     return dateObj.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
// };

// const InteractiveCitySelector = ({
//   country,
//   cities,
//   maxNights, 
//   startDate, // Ensure this prop is passed from parent
//   onAddCity,
//   onRemoveCity,
//   onNightsChange,
//   onReorder
// }) => {
    
//   const countryData = cityData.find((d) => d.Destination === country);
//   const suggestions = countryData?.Places?.slice(0, 15) || [];
//   const addedCityNames = new Set(cities.map((city) => city.name));

//   // --- Calculate Usage ---
//   const usedNights = cities.reduce((acc, city) => acc + city.nights, 0);
//   const remainingNights = maxNights - usedNights;
//   const isLimitReached = usedNights >= maxNights;

//   // --- Drag & Drop Logic ---
//   const dragItem = useRef();
//   const dragOverItem = useRef();

//   const handleDragStart = (e, position) => {
//     dragItem.current = position;
//     // Add a class for visual feedback
//     e.target.closest('.ics-selected-card').classList.add('dragging');
//   };

//   const handleDragEnter = (e, position) => {
//     dragOverItem.current = position;
//   };

//   const handleDragEnd = (e) => {
//     e.target.closest('.ics-selected-card').classList.remove('dragging');
//     const copyListItems = [...cities];
//     const dragItemContent = copyListItems[dragItem.current];
//     copyListItems.splice(dragItem.current, 1);
//     copyListItems.splice(dragOverItem.current, 0, dragItemContent);
//     dragItem.current = null;
//     dragOverItem.current = null;
//     onReorder(copyListItems);
//   };

//   // --- Date Calculation Setup ---
//   // Start calculating dates from the provided startDate
//   let timelineBuilder = new Date(startDate);
//   if (isNaN(timelineBuilder.getTime())) timelineBuilder = new Date();

//   if (!country) return <div className="ics-empty">Please select a destination first.</div>;

//   return (
//     <div className="ics-wrapper">
        
//         {/* --- USAGE ALERT --- */}
//         <div className={`ics-alert-bar ${isLimitReached ? 'limit-reached' : ''}`}>
//             <div className="ics-alert-info">
//                 <RiInformationLine size={18}/>
//                 <span>Total Nights Allocated: <strong>{usedNights} / {maxNights}</strong></span>
//             </div>
//             <span className="ics-alert-status">
//                 {remainingNights > 0 ? `${remainingNights} nights remaining` : "Limit reached"}
//             </span>
//         </div>

//         <div className="ics-two-col-layout">
            
//             {/* LEFT COLUMN: SELECTED PLACES */}
//             <div className="ics-column left-panel">
//                 <h4 className="ics-col-title">Selected Places ({cities.length})</h4>
                
//                 <div className="ics-scroll-area">
//                     {cities.length === 0 ? (
//                         <div className="ics-empty-placeholder">
//                             <RiHotelBedLine size={40} />
//                             <p>No places added yet.<br/>Select from the right.</p>
//                         </div>
//                     ) : (
//                         <div className="ics-selected-list">
//                             {cities.map((city, index) => {
//                                 // 1. Calculate Start Date for this specific slot
//                                 const slotStartDate = new Date(timelineBuilder);
                                
//                                 // 2. Calculate End Date for this specific slot
//                                 const slotEndDate = new Date(timelineBuilder);
//                                 slotEndDate.setDate(slotEndDate.getDate() + city.nights);

//                                 // 3. Update builder for the NEXT item in the loop
//                                 timelineBuilder = new Date(slotEndDate);

//                                 return (
//                                     <div 
//                                         key={city.name} 
//                                         className="ics-selected-card"
//                                         draggable
//                                         onDragStart={(e) => handleDragStart(e, index)}
//                                         onDragEnter={(e) => handleDragEnter(e, index)}
//                                         onDragEnd={handleDragEnd}
//                                     >
//                                         {/* Drag Handle */}
//                                         <div className="ics-drag-handle">
//                                             <RiDraggable />
//                                         </div>

//                                         <div className="ics-card-content">
//                                             {/* Date Row with Icon */}
//                                             <div className="ics-date-row">
//                                                 <RiCalendarEventLine className="ics-cal-icon"/> 
//                                                 <span className="ics-date-text">
//                                                     {formatDateShort(slotStartDate)} 
//                                                     {city.nights > 1 ? ` - ${formatDateShort(slotEndDate)}` : ''}
//                                                 </span>
//                                             </div>

//                                             <div className="ics-main-row">
//                                                 <div className="ics-info-block">
//                                                     <span className="ics-city-name">{city.name}</span>
//                                                     <span className="ics-nights-badge">{city.nights} Night{city.nights > 1 ? 's' : ''}</span>
//                                                 </div>

//                                                 <div className="ics-actions-block">
//                                                     {/* Counter */}
//                                                     <div className="ics-counter">
//                                                         <button 
//                                                             onClick={() => onNightsChange(city.name, -1)} 
//                                                             disabled={city.nights <= 1}
//                                                         >
//                                                             <RiSubtractLine/>
//                                                         </button>
//                                                         <span>{city.nights}</span>
//                                                         <button 
//                                                             onClick={() => onNightsChange(city.name, 1)} 
//                                                             disabled={isLimitReached}
//                                                             className={isLimitReached ? 'disabled' : ''}
//                                                         >
//                                                             <RiAddLine/>
//                                                         </button>
//                                                     </div>
//                                                     {/* Delete */}
//                                                     <button 
//                                                         className="ics-delete-btn" 
//                                                         onClick={() => onRemoveCity(city.name)}
//                                                     >
//                                                         <RiDeleteBinLine />
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 );
//                             })}
//                         </div>
//                     )}
//                 </div>
//             </div>

//             {/* RIGHT COLUMN: SUGGESTIONS */}
//             <div className="ics-column right-panel">
//                 <h4 className="ics-col-title">Suggestions for {country}</h4>
//                 <div className="ics-scroll-area">
//                     <div className="ics-suggestions-grid">
//                         {suggestions.map((cityName) => {
//                             if (addedCityNames.has(cityName)) return null;
                            
//                             return (
//                                 <button 
//                                     key={cityName} 
//                                     className="ics-suggestion-card"
//                                     onClick={() => !isLimitReached && onAddCity(cityName)}
//                                     disabled={isLimitReached}
//                                 >
//                                     <span className="name">{cityName}</span>
//                                     <span className="add-txt">
//                                         {isLimitReached ? 'Full' : '+ Add'}
//                                     </span>
//                                 </button>
//                             );
//                         })}
//                         {suggestions.length === 0 && <div className="text-muted">No suggestions available.</div>}
//                     </div>
//                 </div>
//             </div>

//         </div>
//     </div>
//   );
// };

// export default InteractiveCitySelector;



import React, { useRef } from 'react';
import { 
    RiAddLine, 
    RiSubtractLine, 
    RiHotelBedLine,
    RiInformationLine,
    RiDeleteBinLine,
    RiDraggable,
    RiCalendarEventLine
} from "react-icons/ri";

// Updated import path
import cityData from "../../Data/DestinationPlaces.json";
import "./InteractiveCitySelector.css";

const formatDateShort = (dateObj) => {
    if (!dateObj || isNaN(dateObj.getTime())) return '';
    return dateObj.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
};

const InteractiveCitySelector = ({
  country,
  cities,
  maxNights, 
  startDate, 
  onAddCity,
  onRemoveCity,
  onNightsChange,
  onReorder
}) => {
    
  // Find the country data
  const countryData = cityData.find((d) => d.destination === country);
  
  // FIX: Removed .slice(0, 15) to show ALL places in the JSON order
  const suggestions = countryData?.places || []; 
  
  const addedCityNames = new Set(cities.map((city) => city.name));

  const usedNights = cities.reduce((acc, city) => acc + city.nights, 0);
  const remainingNights = maxNights - usedNights;
  const isLimitReached = usedNights >= maxNights;

  const dragItem = useRef();
  const dragOverItem = useRef();

  const handleDragStart = (e, position) => {
    dragItem.current = position;
    e.target.closest('.ics-selected-card').classList.add('dragging');
  };

  const handleDragEnter = (e, position) => {
    dragOverItem.current = position;
  };

  const handleDragEnd = (e) => {
    e.target.closest('.ics-selected-card').classList.remove('dragging');
    const copyListItems = [...cities];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    onReorder(copyListItems);
  };

  let timelineBuilder = new Date(startDate);
  if (isNaN(timelineBuilder.getTime())) timelineBuilder = new Date();

  if (!country) return <div className="ics-empty">Please select a destination first.</div>;

  return (
    <div className="ics-wrapper">
        <div className={`ics-alert-bar ${isLimitReached ? 'limit-reached' : ''}`}>
            <div className="ics-alert-info">
                <RiInformationLine size={18}/>
                <span>Total Nights Allocated: <strong>{usedNights} / {maxNights}</strong></span>
            </div>
            <span className="ics-alert-status">
                {remainingNights > 0 ? `${remainingNights} nights remaining` : "Limit reached"}
            </span>
        </div>

        <div className="ics-two-col-layout">
            <div className="ics-column left-panel">
                <h4 className="ics-col-title">Selected Places ({cities.length})</h4>
                <div className="ics-scroll-area">
                    {cities.length === 0 ? (
                        <div className="ics-empty-placeholder">
                            <RiHotelBedLine size={40} />
                            <p>No places added yet.<br/>Select from the right.</p>
                        </div>
                    ) : (
                        <div className="ics-selected-list">
                            {cities.map((city, index) => {
                                const slotStartDate = new Date(timelineBuilder);
                                const slotEndDate = new Date(timelineBuilder);
                                slotEndDate.setDate(slotEndDate.getDate() + city.nights);
                                timelineBuilder = new Date(slotEndDate);

                                return (
                                    <div 
                                        key={city.name} 
                                        className="ics-selected-card"
                                        draggable
                                        onDragStart={(e) => handleDragStart(e, index)}
                                        onDragEnter={(e) => handleDragEnter(e, index)}
                                        onDragEnd={handleDragEnd}
                                    >
                                        <div className="ics-drag-handle"><RiDraggable /></div>
                                        <div className="ics-card-content">
                                            <div className="ics-date-row">
                                                <RiCalendarEventLine className="ics-cal-icon"/> 
                                                <span className="ics-date-text">
                                                    {formatDateShort(slotStartDate)} 
                                                    {city.nights > 1 ? ` - ${formatDateShort(slotEndDate)}` : ''}
                                                </span>
                                            </div>
                                            <div className="ics-main-row">
                                                <div className="ics-info-block">
                                                    <span className="ics-city-name">{city.name}</span>
                                                    <span className="ics-nights-badge">{city.nights} Night{city.nights > 1 ? 's' : ''}</span>
                                                </div>
                                                <div className="ics-actions-block">
                                                    <div className="ics-counter">
                                                        <button onClick={() => onNightsChange(city.name, -1)} disabled={city.nights <= 1}><RiSubtractLine/></button>
                                                        <span>{city.nights}</span>
                                                        <button onClick={() => onNightsChange(city.name, 1)} disabled={isLimitReached} className={isLimitReached ? 'disabled' : ''}><RiAddLine/></button>
                                                    </div>
                                                    <button className="ics-delete-btn" onClick={() => onRemoveCity(city.name)}><RiDeleteBinLine /></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>

            <div className="ics-column right-panel">
                <h4 className="ics-col-title">Suggestions for {country}</h4>
                <div className="ics-scroll-area">
                    <div className="ics-suggestions-grid">
                        {suggestions.map((place) => {
                            const cityName = place.placeName;
                            if (addedCityNames.has(cityName)) return null;
                            
                            return (
                                <button 
                                    key={cityName} 
                                    className="ics-suggestion-card"
                                    onClick={() => !isLimitReached && onAddCity(cityName)}
                                    disabled={isLimitReached}
                                >
                                    <span className="name">{cityName}</span>
                                    <span className="add-txt">{isLimitReached ? 'Full' : '+ Add'}</span>
                                </button>
                            );
                        })}
                        {suggestions.length === 0 && <div className="text-muted">No suggestions available.</div>}
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default InteractiveCitySelector;